import { create } from "zustand";

const useInvoiceItemTypeStore = create((set) => ({
  invoiceItemTypes: [], // invoiceitemtypes
  setInvoiceItemTypes: (value) =>
    set((state) => ({ ...state, invoiceItemTypes: value })),
}));

export default useInvoiceItemTypeStore;
